import React from 'react';
import Accommodations from './Accommodations';
import { AccommodationLookup } from './lookup';
import type { StudentAccommodationListProps } from './Accommodations.types';

const AccommodationList: React.FC<StudentAccommodationListProps> = ({
  accommodations = [],
  studentId,
  type = 'digital_cb', // Default to 'digital_cb' table type
  links = true,
}) => {
  return (
    <>
      {AccommodationLookup(accommodations, type).map((item, index) => (
        <li
          key={`accommodations_${index}`}
          id={`Student-${studentId}-Accommodation-${item?.title}`}
          aria-label={`Accommodation: ${item?.title} for student id - ${studentId}`}
        >
          <Accommodations item={item} studentId={studentId} links={links} />
        </li>
      ))}
    </>
  );
};

export default AccommodationList;
